// extracted by mini-css-extract-plugin
export default {"root":"LabNotesContainer_root__9FJ+W","formTitle":"LabNotesContainer_formTitle__oHMzU","main":"LabNotesContainer_main__jb2jT","tableWrap":"LabNotesContainer_tableWrap__PIUK3"};